import React from 'react';
import { Button, Card, CardBody, CardImg, CardSubtitle, CardText, CardTitle } from 'reactstrap';
import './Card.css';

function ProjectCard({ project }) {
  const { screenshot, name, technologies, github, desc, live } = project;
  return (
    <Card
      className="shadow cardWith"
      style={{
        margin: '10px',
        backgroundColor: 'white',
        color: 'black',
        padding: '5px',
      }}
    >
      <CardImg top width="100%" style={{ height: '150px' }} src={screenshot} alt="Card image cap" />
      <CardBody className="p-3">
        <CardTitle tag="h5">{name}</CardTitle>
        <div className=" d-flex flex-wrap">
          {technologies.map((tech) => (
            <CardSubtitle
              key={tech}
              tag="h6"
              className="m-1 text-muted bg-info rounded p-1 text-white"
            >
              {tech}
            </CardSubtitle>
          ))}
        </div>
        <CardText>{desc?.substring(0, 240)}...</CardText>
        {live ? (
          <Button target="_" href={live}>
            Visit
          </Button>
        ) : (
          ''
        )}
        {github ? (
          <Button target="_" href={github}>
            Github
          </Button>
        ) : (
          ''
        )}
      </CardBody>
    </Card>
  );
}

export default ProjectCard;
